import React from 'react'
import cx from 'classnames'
import { string, func } from 'prop-types'

import { ConfirmationIcon, DownloadIcon } from '@wf-sl/common-icons'

import { useFileDropzone } from './hooks/use-file-dropzone'

import styles from './drag-and-drop-area.module.css'

const propTypes = {
    dropLayerText: string,
    onFileDrop: func,
    dropzoneId: string
}

const defaultProps = {
    dropLayerText: '',
    onFileDrop: Function.prototype
}

export const FileDndDropzone = function (props) {
    const { children, className, dropLayerText, dropzoneId, onFileDrop } = props
    const { isDragging, isOver, onDragEnter, onDragLeave, onDrop } = useFileDropzone({
        id: dropzoneId ?? 'widgets-file-dnd-dropzone-' + Date.now(),
        onFileDrop
    })

    const wrapperClass = cx(styles['dnd-wrapper'], { [styles['in-zone']]: isOver }, className, 't3sel-dnd-area')

    return (
        <div className={wrapperClass}>
            {isDragging && (
                <div
                    className={cx(styles['drop-area'], 't3sel-dnd-layer')}
                    onDragEnter={onDragEnter}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                >
                    <div className={styles['dnd-layer']}>
                        {isOver ? (
                            <ConfirmationIcon className={styles['yes-icon']} />
                        ) : (
                            <DownloadIcon rotate="180deg" className={styles['upload-icon']} />
                        )}
                        <h2 className={styles['dnd-layer-text']}>{dropLayerText}</h2>
                    </div>
                </div>
            )}
            {children}
        </div>
    )
}

FileDndDropzone.propTypes = propTypes
FileDndDropzone.defaultProps = defaultProps
